module.exports = __webpack_public_path__ + "media/educators/cis-d0262de7.png";